import { useEffect, useRef, useState } from "react";
import logoDuda from "@/assets/logo-duda-real.png";
import logoGoogle from "@/assets/logo-google-partner-real.svg";
import logoZapier from "@/assets/logo-zapier-real.png";
import logoFbBlueprint from "@/assets/logo-fb-blueprint.webp";
import logoCallRail from "@/assets/logo-callrail.webp";
import logoHighLevel from "@/assets/logo-highlevel.webp";
import logoMobileMonkey from "@/assets/logo-mobilemonkey.webp";
import logoManyChat from "@/assets/logo-manychat.webp";
import logoSemrush from "@/assets/logo-semrush.webp";
import logoAhrefs from "@/assets/logo-ahrefs.webp";

const logos = [
  { src: logoGoogle, alt: "Google Partner", height_class: "h-10 md:h-11", width: 62, height: 44 },
  { src: logoFbBlueprint, alt: "Meta Blueprint Certified", height_class: "h-8 md:h-9", width: 57, height: 36 },
  { src: logoCallRail, alt: "CallRail Partner", height_class: "h-8 md:h-9", width: 36, height: 36 },
  { src: logoHighLevel, alt: "GoHighLevel Partner", height_class: "h-7 md:h-8", width: 32, height: 32 },
  { src: logoSemrush, alt: "Semrush Partner", height_class: "h-8 md:h-9", width: 36, height: 36 },
  { src: logoAhrefs, alt: "Ahrefs Partner", height_class: "h-7 md:h-8", width: 32, height: 32 },
  { src: logoDuda, alt: "Duda Expert Partner", height_class: "h-7 md:h-8", width: 57, height: 32 },
  { src: logoZapier, alt: "Zapier Integration Partner", height_class: "h-8 md:h-9", width: 36, height: 36 },
  { src: logoMobileMonkey, alt: "MobileMonkey Partner", height_class: "h-7 md:h-8", width: 32, height: 32 },
  { src: logoManyChat, alt: "ManyChat Partner", height_class: "h-8 md:h-9", width: 36, height: 36 },
];

const TrustLogos = () => {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.3 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div className={`${visible ? "reveal-up" : "opacity-0"}`} ref={ref}>
      <div className="flex flex-wrap items-center justify-center gap-8 md:gap-12">
        {logos.map((logo, i) => (
          <img
            key={`${logo.alt}-${i}`}
            src={logo.src}
            alt={logo.alt}
            width={logo.width}
            height={logo.height}
            className={`${logo.height_class} object-contain opacity-60 hover:opacity-100 transition-opacity duration-200`}
            loading="lazy"
          />
        ))}
      </div>
    </div>
  );
};

export default TrustLogos;
